import { API_SERVICE } from "./root";
//  导入pb文件
//  ticket的proto
import { TicketServiceClient } from "@/pbjs/external/ticket/ticket_grpc_web_pb";
//  命名请求对象
let ticketClient: any = new TicketServiceClient(API_SERVICE, null, null);

export { ticketClient };
